module.exports = __webpack_public_path__ + "static/media/background.8c336a71.jpg";